let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bOjyK")).then(() => parcelRequire('3jEPG'));